import React, { useState } from 'react';
import { PhonotacticsInput } from '../../phonotactics/wordGenerator';
import { phonotacticsFromString, phonotacticsToString } from './phonotacticsAsString';

// local storage key for storing custom phonotactics
const customPhonotacticsKey = 'custom-phonotactics';

/** first try phonotacticsInitial, then previously saved, then fallback */
export interface EditPhonotacticsProps {
  /** start with these phonotactics, if present */
  readonly phonotacticsInitial?: PhonotacticsInput;
  /** if !phonotacticsInitial && no previously saved phonotactics, use these */
  readonly phonotacticsFallback: PhonotacticsInput;
  readonly onChange: (phonotactics: PhonotacticsInput) => void;
}

/**
 * shows phonotactics as an editable string, which it can save & reload
 */
export function EditPhonotactics(props: EditPhonotacticsProps) {
  const [stringified, setStringified] = useState(() => initialString(props));

  function applyPhonotactics() {
    const phonotactics = phonotacticsFromString(stringified);
    window.localStorage.setItem(customPhonotacticsKey, stringified);
    props.onChange(phonotactics);
  }

  return (
    <div>
      <button onClick={() => applyPhonotactics()}>use custom phonotactics</button>
      <br />
      <textarea cols={80} rows={15} spellCheck={false} value={stringified} onChange={(event) => setStringified(event.target.value)} />
    </div>
  );
}

function initialString(props: EditPhonotacticsProps): string {
  if (props.phonotacticsInitial) {
    return phonotacticsToString(props.phonotacticsInitial);
  }
  const text = window.localStorage.getItem(customPhonotacticsKey);
  if (text != null) {
    return text;
  }
  return phonotacticsToString(props.phonotacticsFallback);
}
